exports.shouldUpdateScroll = ({ routerProps: { location } }) => {
  return location.href.indexOf('#') > -1 ? false : true;
};
